// removed by extract-text-webpack-plugin
module.exports = {"dragBar":"_1G2mUuQrEp1-FapBzPEsg4","progressBar":"_1HiAgh8YXoqRpGw-BiuG-t","progress":"_2ECVh2l_bKE-D0PBTSX4Sv","subProgress":"R32Qw2eA4ZBSrUhV7_gvY","dragHolder":"S-Rklm2ubBJxQcAyVVTqW","dragSlider":"_1F1hn5ETAKnGKzjoJYR5kz","dragSlide":"_3CQmkq5C4hw0mAjC8j4pIy","dragPoint":"_1_m1cXxRZ1HRWz3MtqChcy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DragBar/DragBar.scss
// module id = 1262
// module chunks = 1